import { getLink } from "../../../utils/utils";

const content = {
	esp: (
		`
		<p class="mb-3">
			En la ĉefurbon kunvenas dekmiloj da personoj. Miloj staras sur la ĉefa placo de Kijivo dum multaj tagoj, jam 2 semajnojn!
		</p>
		
		<p class="mb-3">
			Ili protektas demokration. Tre bona afero, certe. Sed, pardonu, en malvarmo homo pli ofte emas al necesejo. Tiuj miloj de „gastoj de la ĉefurbo” , kiuj konsolidiĝis sur la Sendependeca Placo, ne povas viziti necesejon tuj kiam necesas: dum oni trapenetras el la centro de la tumulto ĝis la celo, ne malpli ol duonhoro pasos…
		</p>
		
		<p class="mb-3">
			Kaj unusola banejo sur Mihajlovskaja, 22, ne sufiĉas por dekmiloj de malpuraj manifestantoj.
		</p>
		
		<p class="mb-3">
			Sed veturi al pli foraj – perdi sian lokon sur la placo: kiu demokration defendos, dum ni nin banos kaj ĝuiĝos? Kaj pagas oni por la tuta tago, ne por duono…
		</p>

		<p class="mb-3">
			Do pli kaj pli fiodoras demokratio sur la stratoj de iam belega urbo Kijivo.
		</p>
	`
	)
}

const itemName = {
	esp: 'Fiodora demokratio'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp:{
		itemName: itemName.esp,
		itemContent: content.esp
	}
}

export default item;